import { WebLink } from '@news-mono/web-common'
import React from 'react'
import {
    StyledCNBCLogo,
    StyledFeatureContainer,
    StyledFeatureSectionHeader,
    StyledThor,
} from '../../compositions/Thor/Thor.styled'
import { QueensLegacyLogo } from '../../logos/QueensLegacy/QueensLegacyLogo'
import { TheWestHomeOfGrandFinalLogo } from '../../logos/TheWestLogoGrandFinal/TheWestHomeOfGrandFinalLogo'
import { ThemeOverrider } from '../../themes/ThemeOverrider/ThemeOverrider'
import { ContainerWidth, ThemeMargins } from '../../__styling/settings/metrics'
import { ThemeOverrideTypes } from '../../__styling/themes'

export interface ThorProps {
    mainContent: React.ReactElement<any>
    hasBackgroundFill?: boolean
    /** If true or undefined, will default to the outer margin of the theme */
    horizontalGutters?: boolean | keyof ThemeMargins
    /** If true or undefined, will default to the outer margin of the theme */
    verticalGutters?: boolean | keyof ThemeMargins
    verticalSpacing?: keyof ThemeMargins
    containerWidth?: ContainerWidth
    themeOverride?: ThemeOverrideTypes
}

export const Thor: React.FC<ThorProps> = ({
    mainContent,
    hasBackgroundFill,
    horizontalGutters,
    verticalGutters,
    verticalSpacing,
    containerWidth,
    themeOverride,
}) => {
    const styledThor = (
        <StyledThor
            hasBackgroundFill={hasBackgroundFill}
            horizontalGutters={horizontalGutters}
            verticalGutters={verticalGutters}
            verticalSpacing={verticalSpacing}
            containerWidth={containerWidth || 1020}
        >
            {mainContent}
        </StyledThor>
    )
    if (themeOverride === 'grand-final') {
        return (
            <ThemeOverrider override={themeOverride}>
                <StyledFeatureContainer>
                    <WebLink to="/sport/afl">
                        <TheWestHomeOfGrandFinalLogo logoWidth={256} />
                    </WebLink>

                    <StyledFeatureSectionHeader
                        heading="Full Coverage"
                        headingUrl="/sport/afl"
                        showChevron
                    />
                </StyledFeatureContainer>
                {styledThor}
            </ThemeOverrider>
        )
    }

    if (themeOverride === 'queens-legacy') {
        return (
            <ThemeOverrider override={themeOverride}>
                <StyledFeatureContainer>
                    <WebLink to="/news/queen-elizabeth-ii">
                        <QueensLegacyLogo logoWidth={400} />
                    </WebLink>

                    <StyledFeatureSectionHeader
                        heading="More Stories"
                        headingUrl="/news/queen-elizabeth-ii"
                        showChevron
                    />
                </StyledFeatureContainer>
                {styledThor}
            </ThemeOverrider>
        )
    }

    if (themeOverride === 'cnbc') {
        //We don't want to display anything if we don't have any content.
        if (!mainContent) {
            return (
                <ThemeOverrider override={themeOverride}>
                    {styledThor}
                </ThemeOverrider>
            )
        }

        const CNBCLogoSource = require('../../logos/CNBCLogos/CNBC_Logo_White.png')

        return (
            <ThemeOverrider override={themeOverride}>
                <StyledFeatureContainer>
                    <WebLink to="/business/cnbc">
                        <StyledCNBCLogo src={CNBCLogoSource} />
                    </WebLink>
                    <StyledFeatureSectionHeader
                        heading="More stories"
                        headingUrl="/business/cnbc"
                        showChevron
                    />
                </StyledFeatureContainer>
                {styledThor}
            </ThemeOverrider>
        )
    }

    return (
        <ThemeOverrider override={themeOverride}>{styledThor}</ThemeOverrider>
    )
}

Thor.displayName = 'ThorComposition'
